import * as React from 'react';
import { ITableConfig } from './index';
import TableHeader from './TableHeader';
import TableBody from './TableBody';
import Pager from './Pager';
import PagedResultSet from '../../../models/common/PagedResultSet';
import './Table.scss';

// Define the shape of the sort configuration object
interface ISortConfig {
    field: string | null;
    isDescending: boolean | null;
}

// Update ITableProps to include the new OPTIONAL properties for sorting
export interface ITableProps {
    enablePaging?: boolean;
    fixedPager?: boolean;
    isLoading?: boolean;
    tableConfig: ITableConfig;
    // tslint:disable-next-line
    data: PagedResultSet<object> | undefined;
    style?: React.CSSProperties;
    onRowClick?: (id: number | string) => void;
    onRowDoubleClick?: (id: number | string) => void;
    onPageChange?: (id: number) => void;

    // --- OPTIONAL SORTING PROPS ---
    // A callback function to trigger a sort on the parent component
    onSort?: (field: string) => void;
    // The current sort state (which column and direction)
    sortConfig?: ISortConfig;
}

const Table: React.StatelessComponent<ITableProps> = (props) => {
    const table = (
        <table style={props.style}>
            {/* Pass the optional sort props down to the header */}
            <TableHeader isLoading={props.isLoading} columns={props.tableConfig.columns} onSort={props.onSort} sortConfig={props.sortConfig} />
            <TableBody
                isLoading={props.isLoading}
                rowCount={props.tableConfig.rowCount}
                columns={props.tableConfig.columns}
                data={props.data ? props.data.items : []}
                idField={props.tableConfig.idField}
                onRowClick={props.onRowClick}
                onRowDoubleClick={props.onRowDoubleClick}
            />
        </table>
    );

    // Logic updated to ensure all blocks use curly braces
    if (props.enablePaging) {
        if (props.data) {
            if (props.fixedPager) {
                return (
                    <div className="lh-table-layout">
                        <div className="lh-table-scroll-region">{table}</div>
                        <div className="lh-table-footer-region">
                            <Pager
                                pageSize={props.data.pageSize}
                                pageNumber={props.data.pageNumber}
                                currentPageCount={props.data.items.length}
                                totalRecords={props.data.totalRecords}
                                onPageChange={props.onPageChange}
                            />
                        </div>
                    </div>
                );
            }
            return (
                <>
                    {table}
                    <Pager
                        pageSize={props.data.pageSize}
                        pageNumber={props.data.pageNumber}
                        currentPageCount={props.data.items.length}
                        totalRecords={props.data.totalRecords}
                        onPageChange={props.onPageChange}
                    />
                </>
            );
        } else {
            if (props.fixedPager) {
                return (
                    <div className="lh-table-layout">
                        <div className="lh-table-scroll-region">{table}</div>
                        <div className="lh-table-footer-region">
                            <div>...</div>
                        </div>
                    </div>
                );
            }
            return (
                <>
                    {table}
                    <div>...</div>
                </>
            );
        }
    } else {
        // Curly braces added for consistency
        return table;
    }
};

export default Table;



// WEBPACK FOOTER //
// ./src/components/common/table/Table.tsx